module.exports = __webpack_public_path__ + "static/img/200241.50e4ab5c.png";